import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=09d55ce4&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=09d55ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d55ce4",
  null
  
)

export default component.exports